module.exports = __webpack_public_path__ + "static/media/20160512_185128.1e57d301.jpg";